/*
 * Copyright 2015 Palantir Technologies, Inc. All rights reserved.
 *
 * Licensed under the terms of the LICENSE file distributed with this project.
 */
import * as tslib_1 from "tslib";
import * as classNames from "classnames";
import * as React from "react";
import * as Classes from "../../common/classes";
var Menu = (function (_super) {
    tslib_1.__extends(Menu, _super);
    function Menu() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Menu.prototype.render = function () {
        return (React.createElement("ul", { className: classNames(Classes.MENU, this.props.className), ref: this.props.ulRef }, this.props.children));
    };
    Menu.displayName = "Blueprint.Menu";
    return Menu;
}(React.Component));
export { Menu };
export var MenuFactory = React.createFactory(Menu);



//////////////////
// WEBPACK FOOTER
// ./~/@blueprintjs/core/dist/esm/components/menu/menu.js
// module id = 301
// module chunks = 0